import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UnitSelectionCandidate} from '../../model/unit-selection-candidate';
import {ScheduleLineInput} from '../../model/schedule-line-input';
import {TagInformation} from '../../model/tag-information';
import {DialogService} from '../../services/dialog.service';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {MatInput} from '@angular/material/input';
import {FormsModule} from '@angular/forms';
import {MatFormField, MatLabel} from '@angular/material/form-field';


@Component({
    selector: 'app-add-schedule-line-dialog',
    templateUrl: './add-schedule-line-dialog.component.html',
    styleUrls: ['./add-schedule-line-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, FormsModule, MatInput, MatButton, MatIcon]
})
export class AddScheduleLineDialogComponent {
  private readonly dialogService = inject(DialogService);
  private readonly dialogRef = inject<MatDialogRef<AddScheduleLineDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  private readonly scheduleId: string;
  private readonly candidate: UnitSelectionCandidate;
  private readonly tags = signal<TagInformation[]>(undefined!);
  isBusy!: boolean;
  errorMessage!: string;
  quantity: number;

  constructor() {
    this.scheduleId = this.data.scheduleId;
    this.candidate = this.data.candidate;
    this.quantity = 1;
    this.tags.set([]);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  showTagsDialog(): void {
    if (this.quantity > 0) {
      if (this.tags().length > this.quantity) {
        this.tags.set(this.tags().slice(0, this.quantity));
      }
      this.dialogService.showTagManagementDialog(this.tags(), 460, this.quantity, false).subscribe({
        next: (results: TagInformation[]) => {
          if (results && results.length > 0) {
            this.tags.set(results);
          }
        }
      });
    }
  }

  save(): void {
    this.errorMessage = undefined!;
    this.isBusy = true;
    const input = new ScheduleLineInput();
    input.scheduleId = this.scheduleId;
    input.candidate = this.candidate;
    input.quantity = this.quantity;
    input.tagInformation = this.tags();
    this.dialogRef.close(input);
  }

}
